import gsap from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);

let headAnim = document.getElementsByClassName("headingAnim");
let secondSec = document.getElementById("scrolled");
let button = document.getElementById("scrollButton");

let myCircle = document.getElementsByClassName("ellipse");
let ellipse = myCircle[0].childNodes[1];

let tl = new gsap.timeline({ defaults: { ease: "SlowMo.easeOut" } });

button.onclick = () => {
  // gsap.to(window, {duration: 1.5, scrollTo:"#scrolled",  offsetY: 50, ease: "Power3.easeIn"});
  gsap.to(window, {
    duration: 1.2,
    scrollTo: "#scrolled",
    ease: "Circ.easeOut",
  });
};

tl.to(headAnim, { y: "0%", duration: 0.7, stagger: 0.2 });

// AND MAYBE TRY THE SCALE FUCNTIONS WITH HOVER EFFECTS
tl.to(ellipse, { "--myStroke": 0, duration: 5, delay: -4 });
